import React, { Component } from "react"

import ErrorMessageDialog from "../ui/ErrorMessageDialog.js"

import Screen from '../ui/Screen'

import ControlPanel from "./BoxesScreen/ControlPanel.js"
import BoxesList from "./BoxesScreen/BoxesList.js"

import CreateBoxDialog from "./BoxesScreen/CreateBoxDialog.js"
import EditBoxDialog from "./BoxesScreen/EditBoxDialog.js"
import DeleteBoxDialog from "./BoxesScreen/DeleteBoxDialog.js"

import api from "../api.js"

class BoxesScreen extends Component {

    constructor(props) {

        super(props)

        this.state = {
            dialog: undefined,
            screen: undefined,
            selected: undefined,
            boxes: [],
        }

        this.handle_error = this.handle_error.bind(this)

        this.handle_BoxesList_onBoxClick = this.handle_BoxesList_onBoxClick.bind(this)
        this.handle_BoxesList_onBoxDoubleClick = this.handle_BoxesList_onBoxDoubleClick.bind(this)

        this.handle_ControlPanel_onAddBoxClick = this.handle_ControlPanel_onAddBoxClick.bind(this)
        this.handle_ControlPanel_onEditBoxClick = this.handle_ControlPanel_onEditBoxClick.bind(this)
        this.handle_ControlPanel_onDeleteBoxClick = this.handle_ControlPanel_onDeleteBoxClick.bind(this)
    
    }

	handle_error(error) {
        let message = error instanceof String ? error : error.message
		this.setState({
			dialog: <ErrorMessageDialog 
				message = {message}
				onClose = {() => {
					this.update()
						.then(() => {this.setState({dialog: undefined})})
						.catch(this.handle_error)
				}}
			/>
		})
	}    

    async update() {
        let response = await api.boxes.list()
        this.setState({boxes: response.boxes})
    }

	componentDidMount() {
		this.update().catch(this.handleError)
	}

    handle_BoxesList_onBoxClick(box) {
        this.setState({selected: box})
    }

    handle_BoxesList_onBoxDoubleClick(box) {
        this.handle_ControlPanel_onEditBoxClick(box)
    }

    handle_ControlPanel_onAddBoxClick() {
		this.setState({
			dialog: <CreateBoxDialog
				onCreateBoxClick = {async (box) => {
                    try {
                        await api.boxes.create(box.code)
                        await this.update()
                        this.setState({ dialog: undefined, selected: undefined })
                    }
                    catch (e) {
                        this.handle_error(e)
                    }
				}}
				onCancelClick = {() => {
                    this.setState({ dialog: undefined })
                }}
			/>
		})
    }

    handle_ControlPanel_onEditBoxClick(box) {
		this.setState({
			dialog: <EditBoxDialog
                box = {box}
                onEditBoxClick = {async (box) => {
                    try {
                        await api.boxes.update_code(box.id, box.code)
                        await this.update()
                        this.setState({ dialog: undefined, selected: undefined })
                    }
                    catch (e) {
                        this.handle_error(e)
                    }
				}}
				onCancelClick = {() => {
                    this.setState({ dialog: undefined })
                }}
			/>
		})
    }

    handle_ControlPanel_onDeleteBoxClick (box) {
		this.setState({
			dialog: <DeleteBoxDialog
				box = {box}
				onDeleteBoxClick = {async (box) => {
                    try {
                        await api.boxes.delete(box.id)
                        await this.update()
                        this.setState({dialog: undefined, selected: undefined})
                    }
                    catch (e) {
                        this.handle_error(e)
                    }
				}}
				onCancelClick = {() => {
                    this.setState({dialog: undefined})
                }}
			/>
		})
    }

    render() {

		if (this.state.screen) {
			return this.state.screen
		}

        return <Screen
            onClick = {e => {
                e.stopPropagation()
                if (!this.state.dialog) this.setState({selected: undefined})
            }}
        >
            
            { this.state.dialog }

			<ControlPanel
				selected = {this.state.selected}
				onAddBoxClick = {this.handle_ControlPanel_onAddBoxClick}
				onEditBoxClick = {this.handle_ControlPanel_onEditBoxClick}
				onDeleteBoxClick = {this.handle_ControlPanel_onDeleteBoxClick}
			/>            

            <BoxesList 
                boxes = {this.state.boxes}
                selected = {this.state.selected}
                onBoxClick = {this.handle_BoxesList_onBoxClick}
                onBoxDoubleClick = {this.handle_BoxesList_onBoxDoubleClick}
            />

        </Screen>

    }

}

export default BoxesScreen